/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'fabric.editor.chromeCollapsedPlaceholder': '输入内容......',
  'fabric.editor.editorAssistiveLabel': '主内容区域，开始键入以输入文本。',
  'fabric.editor.headingLink.toolbarHelpTitle': '打开帮助对话框',
};
